/**
 * Menú lateral por rol. El monitor es solo de eventos, así que todos los
 * países ven lo mismo (SV y el resto ya tenían menús idénticos para estos
 * roles); las decenas de archivos por país y rol del backoffice de delivery
 * se reemplazan con esta tabla.
 */
export interface MenuEntry {
    title: string;
    url: string;
    base: string;
    icon: string;
    alert: boolean;
    customIcon?: boolean;
}

const ORDERS: MenuEntry = { title: 'Ordenes', url: '/index/monitor-v3', base: '', icon: 'notifications', alert: false };
const EVENTS: MenuEntry = { title: 'Configuracion de mi Evento', url: '/index/events', base: '', icon: 'calendar-outline', alert: false };
/** Responsable y cliente ven el mismo informe (resumen, barras, cajas, productos, regalías y exportación). */
const REPORTS: MenuEntry = { title: 'Reportes Mi Evento', url: '/index/client-event-totals', base: '', icon: 'newspaper-outline', alert: false };
const CLIENT: MenuEntry = { title: 'Resumen de mi Evento', url: '/index/client-event-totals', base: '', icon: 'newspaper-outline', alert: false };
/** Cocina / chefs: pantalla de comandas (KDS) de las órdenes con productos de cocina. */
const KITCHEN: MenuEntry = { title: 'Cocina', url: '/index/kitchen', base: '', icon: 'restaurant-outline', alert: false };

/**
 * Solo quedan cuatro roles operativos: caja (8), responsable del evento (11),
 * cliente (12) y cocina (14). Los roles administrativos (0, 1, 2, 18) trabajan
 * como responsable, con cocina a la vista.
 */
const MENUS_BY_ROLE: { [role: string]: MenuEntry[] } = {
    '8': [ORDERS],
    '11': [ORDERS, EVENTS, REPORTS],
    '12': [CLIENT],
    '14': [KITCHEN],
};

const ADMIN_MENU: MenuEntry[] = [ORDERS, EVENTS, REPORTS, KITCHEN];

export const ADMIN_ROLES = ['0', '1', '2', '18'];

/** Responsable del evento o administrador: configura eventos y audita cajas. */
export function isEventManager(role: string): boolean {
    const key = String(role === null || role === undefined ? '' : role);
    return key === '11' || ADMIN_ROLES.indexOf(key) >= 0;
}

/** Menú de un rol; los administradores reciben el menú completo de eventos. */
export function menuForRole(role: string): MenuEntry[] {
    const key = String(role === null || role === undefined ? '' : role);
    if (MENUS_BY_ROLE[key]) return MENUS_BY_ROLE[key];
    if (ADMIN_ROLES.indexOf(key) >= 0) return ADMIN_MENU;
    return [];
}

/** Pantalla inicial de cada rol al entrar (login y "página no encontrada"). */
export function homeForRole(role: string): string {
    switch (String(role)) {
        case '12': return '/index/client-event-totals';
        case '14': return '/index/kitchen';
        default: return '/index/monitor-v3';
    }
}
